import React, { Suspense, lazy } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import LoadingDisplay from '@nhl/nhl-react-ui/lib/LoadingDisplay';
import ErrorBoundary from "@nhl/nhl-react-ui/lib/ErrorBoundary";

import PageWrapper from 'media-base-ui/views/layouts/pageWrapper'

import withRightRail from '../withRightRail';

const Home = lazy(() => import('../../pages/home'))
const Game = lazy(() => import('../../pages/game'))
const Games = lazy(() => import('../../pages/games'));
const Stories = withRightRail(lazy(() => import('../../pages/stories')));
const TeamStories = withRightRail(lazy(() => import('../../pages/teamStories')));
const Standings = lazy(() => import('../../pages/standings'));
const RoundRobinStandings = lazy(() => import('../../pages/roundRobinStandings'));
const Teams = lazy(() => import('../../pages/teams'));
const Team = lazy(() => import('../../pages/teamPage'));
const StatsReports = lazy(() => import('../../pages/statsReports'));
const Contacts = lazy(() => import('../../pages/contacts'));
const CorporateCommunicationsContacts = lazy(() => import('../../pages/corporateCommunicationsContacts'));
const ContentLicensing = lazy(() => import('../../pages/contentLicensing'));
const CovidReporting = lazy(() => import('../../pages/covidReporting'));
const Guides = lazy(() => import('../../pages/guides'));
const Headshots = lazy(() => import('../../pages/headshots'));
const LiveUpdates = withRightRail(lazy(() => import('../../pages/liveUpdates')));
const Logos = lazy(() => import('../../pages/logos'));
const MediaAvailabilities = lazy(() => import('../../pages/mediaAvailabilities'));
const ExecutiveBios = lazy(() => import('../../pages/executiveBios'));

// News only needs a Right Rail for non-public pages (ie here) so in this special case we move the wrapping up
const News = withRightRail(lazy(() => import('../../pages/news')));

// News Index can be used a module, so must wrap the right rail here
const NewsIndex = withRightRail(lazy(() => import('../../pages/newsIndex')));
const Publications = lazy(() => import('../../pages/publications'));
const Reports = lazy(() => import('../../pages/reports'));
const ReportsLoading = lazy(() => import('../../pages/reports/components/reportsLoading'));
const SeasonHighs = lazy(() => import('../../pages/seasonHighs'));
const CoachsChallenges = lazy(() => import ('../../pages/coachsChallenges'));
const PenaltyShots = lazy(() => import ('../../pages/penaltyShots'));
const ScreeningRoom = lazy(() => import ('../../pages/screeningRoom'));
const Screener = lazy(() => import ('../../pages/screener'));
const TopicLanding = lazy(() => import ('../../pages/topicLanding'));

const NoMatch = lazy(() => import('media-base-ui/views/pages/noMatch'));

const App = () => (
    <PageWrapper authenticated={true}>
        <ErrorBoundary>
            <Suspense fallback={<LoadingDisplay isLoading={true}/>}>
                <Routes>
                    <Route path="/" element={<Home />}/>
                    <Route path="/games" element={<Games />}/>
                    <Route path="/games/:gameId" element={<Game />}/>
                    <Route path="/standings/round-robin" element={<RoundRobinStandings />} />
                    <Route path="/standings/:view?" element={<Standings />}/>
                    <Route path="/teams" element={<Teams />}/>
                    <Route path="/teams/:slug" element={<Team />}/>
                    <Route path="/coachs-challenges" element={<CoachsChallenges />} />
                    <Route path="/covid-reporting" element={<CovidReporting />} />
                    <Route path="/stories/:season/:name" element={<Stories />} />
                    <Route path="/team-stories/:name" element={<TeamStories />} />
                    <Route path="/live-updates" element={<LiveUpdates />} />
                    <Route path="/penalty-shots" element={<PenaltyShots />} />
                    <Route path="/stats-reports/:category/:reportType" element={<StatsReports />} />
                    <Route path="/media-availabilities/:slug?" element={<MediaAvailabilities />}/>

                    {/* Right Rail Pages */}
                    <Route path="/contacts/:slug?" element={<Contacts />}/>
                    <Route path="/corporate-communications-contacts" element={<CorporateCommunicationsContacts />} />
                    <Route path="/content-licensing" element={<ContentLicensing />}/>
                    <Route path="/executive-bios" element={<ExecutiveBios />}/>
                    <Route path="/guides" element={<Guides />}/>
                    <Route path="/headshots/:slug?" element={<Headshots />}/>
                    <Route path="/logos" element={<Logos />}/>
                    <Route path="/news" element={<NewsIndex />}/>
                    <Route path="/news/:id" element={<News />}/>
                    <Route path="/publications" element={<Publications />}/>
                    <Route path="/reports/loading" element={<ReportsLoading />}/>
                    <Route path="/reports" element={<Reports />}/>
                    <Route path="/season-highs" element={<SeasonHighs />}/>
                    <Route path="/screening-room" element={<ScreeningRoom />}/>
                    <Route path="/screening-room/:id" element={<Screener />}/>
                    <Route path="/topic/:sectionName" element={<TopicLanding />}/>

                    {/*Redirect to solve double active menu items*/}
                    <Route path="/team-media-guides" element={<Navigate to="/teams"/>}/>

                    <Route element={<NoMatch />}/>
                </Routes>
            </Suspense>
        </ErrorBoundary>
    </PageWrapper>
);

export default App;
